'use strict';

import ready from './lib/ready';
import {mutate} from './lib/promise-fastdom';
import promiseIdle from './lib/promise-idle';
import ToggleArea from './lib/ToggleArea';
import nodeFromTemplate from './lib/node-from-template';
import {ButtonBehavior} from './lib/ToggleArea_ButtonBehavior';
import BreakpointObserver from './lib/BreakpointObserver';

ready()
    .then(promiseIdle())
    .then(mutate(function () {

        const area = document.querySelector('.address-menu');
        if (!area) {
            return;
        }

        let ready = null;

        (new BreakpointObserver('address-menu')).observe(query => {
            ready = Promise.resolve(ready)
                .then(reset => typeof reset === 'function' ? reset() : null)
                .then(() => query.matches ? null : initMobile());
        });

        function initMobile() {

            const open = nodeFromTemplate('address-menu-toggle-tpl');
            const close = nodeFromTemplate('address-menu-close-tpl');

            return Promise.resolve()
                .then(mutate(() => {
                    area.insertAdjacentElement('beforebegin', open);
                    area.insertAdjacentElement('afterbegin', close);
                }))
                .then(() => (new ToggleArea(area, 'address-menu', [
                    new ButtonBehavior(open, {
                        closeOnLinkClick: true,
                        closeOnOutsideClick: true,
                        focusAreaOnOpen: true,
                        buttons: [close]
                    })
                ])).ready())
                .then(instance => {
                    return function reset() {
                        return Promise.resolve()
                            .then(() => instance.destroy())
                            .then(mutate(() => {
                                open.parentNode.removeChild(open);
                                close.parentNode.removeChild(close);
                            }));
                    };
                });
        }

    }));